export default "/images/vendor/flag-icon-css/flags/1x1/pm.svg?7582c30f04bd66a4e73cc3975398f85d";